import React from 'react';
import { Link } from 'react-router-dom';

const logo = '/images/logo.png';

const Footer = () => {
  const linkStyles = {
    color: '#888',
    textDecoration: 'none',
    marginBottom: '10px',
    display: 'inline-block',
    fontSize: '16px',
    transition: 'color 0.2s ease-in-out',
  };

  const linkHoverStyle = {
    color: '#000',
  };

  const HoverLink = ({ to, children }) => {
    const [hover, setHover] = React.useState(false);
    return (
      <Link
        to={to}
        style={{ ...linkStyles, ...(hover ? linkHoverStyle : {}) }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {children}
      </Link>
    );
  };

  return (
    <footer style={{
      width: '100%',
      padding: '60px 5% 20px',
      background: '#fff',
      fontFamily: 'Arial, sans-serif',
      color: '#333',
      boxSizing: 'border-box',
      borderTop: '1px solid #eee',
    }}>
      <style>{`
        .footer-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 40px;
            margin-bottom: 40px;
            text-align: center;
        }
        .est-text {
            display: none;
        }
        @media (min-width: 768px) {
            .footer-grid {
                grid-template-columns: 1.5fr 1fr 1fr;
                text-align: left;
            }
            .est-text {
                display: block;
            }
        }
      `}</style>
        <div className="footer-grid">
            {/* Column 1: Brand */}
            <div>
                <img src={logo} alt="Grey" style={{ height: '50px' }} />
            </div>

            {/* Column 2: Policies */}
            <div>
                <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: 'bold' }}>Policies</h3>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <HoverLink to="/terms-of-service">Terms of Service</HoverLink>
                    <HoverLink to="/privacy-policy">Privacy Policy</HoverLink>
                    <HoverLink to="/shipping-policy">Shipping Policy</HoverLink>
                    <HoverLink to="/refund-policy">Refund Policy</HoverLink>
                    <HoverLink to="/contact-information">Contact Information</HoverLink>
                </div>
            </div>

            {/* Column 3: Connect */}
            <div>
                <h3 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: 'bold' }}>Connect</h3>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <a
                        href="https://instagram.com/greydoha"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{...linkStyles, textDecoration: 'none'}}
                        onMouseEnter={e => e.currentTarget.style.color = linkHoverStyle.color}
                        onMouseLeave={e => e.currentTarget.style.color = linkStyles.color}
                     >
                        Instagram
                     </a>
                </div>
            </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
            borderTop: '1px solid #eee',
            paddingTop: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '14px',
            color: '#888',
            textAlign: 'center',
        }}>
            <p style={{ margin: 0 }}>© {new Date().getFullYear()} Grey Specialty Coffee Qatar</p>
        </div>
    </footer>
  );
}

export default Footer;
